<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-pulse"></ngx-spinner>
<ul class="navbar-nav ml-auto">
  <!-- <li>
    <div class="dropdown" ngbDropdown placement="auto">
      
      <a ngbDropdownToggle class="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" role="button" data-toggle="dropdown" data-target="#" aria-expanded="false" href="/page.html">
        <span class="alert-count">8</span>
        <i class="fa-solid fa-bell fa-xl" style="color: white;"></i>
      </a>
      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right notification">
        <div class="noti-head">
          <h6 class="d-inline-block m-b-0">Notifications</h6>
          <div class="float-right">
            <a href="javascript:" class="m-r-10">mark as read</a>
            <a href="javascript:">clear all</a>
          </div>
        </div>
        <perfect-scrollbar [style.max-height]="'300px'">
        <ul class="noti-body">
          <li class="n-title">
            <p class="m-b-0">NEW</p>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>John Doe</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>5 min</span></p>
                <p>New ticket Added</p>
              </div>
            </div>
          </li>
          <li class="n-title">
            <p class="m-b-0">EARLIER</p>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>Joseph William</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>10 min</span></p>
                <p>Prchace New Theme and make payment</p>
              </div>
            </div>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>Sara Soudein</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>12 min</span></p>
                <p>currently login</p>
              </div>
            </div>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>Joseph William</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>30 min</span></p>
                <p>Prchace New Theme and make payment</p>
              </div>
            </div>
          </li>
        </ul>
        </perfect-scrollbar>
        <div class="noti-footer">
          <a href="javascript:">show all</a>
        </div>
      </div>
    </div>
  </li> 
   -->


  <!-- <li>
    <div class="dropdown" ngbDropdown placement="auto">
      <a ngbDropdownToggle href="javascript:" data-toggle="dropdown"><i class="icon feather icon-bell"></i></a>
      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right notification">
        <div class="noti-head">
          <h6 class="d-inline-block m-b-0">Notifications</h6>
          <div class="float-right">
            <a href="javascript:" class="m-r-10">mark as read</a>
            <a href="javascript:">clear all</a>
          </div>
        </div>
        <perfect-scrollbar [style.max-height]="'300px'">
        <ul class="noti-body">
          <li class="n-title">
            <p class="m-b-0">NEW</p>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>John Doe</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>5 min</span></p>
                <p>New ticket Added</p>
              </div>
            </div>
          </li>
          <li class="n-title">
            <p class="m-b-0">EARLIER</p>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>Joseph William</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>10 min</span></p>
                <p>Prchace New Theme and make payment</p>
              </div>
            </div>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>Sara Soudein</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>12 min</span></p>
                <p>currently login</p>
              </div>
            </div>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image">
              <div class="media-body">
                <p><strong>Joseph William</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>30 min</span></p>
                <p>Prchace New Theme and make payment</p>
              </div>
            </div>
          </li>
        </ul>
        </perfect-scrollbar>
        <div class="noti-footer">
          <a href="javascript:">show all</a>
        </div>
      </div>
    </div>
  </li> -->
  <li class="d-none d-md-flex" style="align-items: center; margin-right: 25px;">
    <div class="dropdown" ngbDropdown placement="bottom-right">
      <a ngbDropdownToggle href="javascript:"
        style="font-size: 16px; font-weight: bold; color: white; text-decoration: none; display: flex; align-items: center; gap: 4px; cursor: pointer;">
        <span>{{ selectedCurrencyCode }}</span>
      </a>
      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
        <h6 class="dropdown-header">Select Currency</h6>
        <div class="dropdown-divider"></div>
        <a *ngFor="let curr of availableCurrencies" href="javascript:" (click)="setAppCurrency(curr)"
          class="dropdown-item" [ngClass]="{'active': selectedCurrencyCode === curr.code}">
          <span class="mr-2">{{ curr.symbol }}</span> {{ curr.code }} - {{ curr.name }}
        </a>
      </div>
    </div>
  </li>
  <li *ngIf="auth.isGodMode()" style="display: flex; align-items: center;">
    <span class="badge badge-danger ml-2 animate__animated animate__pulse animate__infinite"
      style="padding: 8px 12px; font-size: 12px; font-weight: bold; border-radius: 20px; box-shadow: 0 4px 10px rgba(255, 82, 82, 0.3);">
      <i class="feather icon-zap mr-1"></i> GOD MODE
    </span>
  </li>
  <li>
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a style="margin-right: 20px;" href="javascript:" ngbDropdownToggle data-toggle="dropdown">
        <span class="cool"><i class="icon feather icon-user"></i></span>
      </a>








      <!-- Notification Bell and Dropdown -->

      <div class="notification-wrapper">
        <a class="notification-bell" (click)="toggleDropdown($event)">
          <i class="fa fa-bell"></i>
          <span *ngIf="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
        </a>

        <div class="notification-dropdown" *ngIf="dropdownOpen">

          <div class="noti-head">
            <h6 class="title">
              <span class="primary"><i class="fa fa-circle-info"></i></span>
              Notifications


            </h6>

            <div class="actions">


              <span class="sound" (click)="toggleSound()">
                <i class="fa" [ngClass]="soundEnabled ? 'fa-volume-up' : 'fa-volume-mute'"></i>
                <span class="m-r-10 sound">{{ soundEnabled ? 'Sound On' : 'Sound Off' }}</span>
              </span>

              <span class="danger"><i class="fa fa-trash"></i></span>
              <span class="m-r-10 danger" (click)="clearAll()">Clear All</span>
            </div>



          </div>


          <div class="noti-body">
            <div *ngFor="let note of notifications" class="notification-item" [ngClass]="note.status">
              <h4 [ngStyle]="{ color: note.status === 'unread' ? '#0b4180' : '#666' }">
                {{ note.title }}
              </h4>
              <p [ngStyle]="{ color: note.status === 'unread' ? '#4a90e2' : '#999' }">
                <ng-container *ngIf="!note.expanded">
                  {{ note.message | slice:0:truncateLength }}
                  <span *ngIf="note.message.length > truncateLength">...</span>
                </ng-container>

                <ng-container *ngIf="note.expanded">
                  {{ note.message }}
                </ng-container>
                <a *ngIf="note.message.length > truncateLength" (click)="note.expanded = !note.expanded"
                  class="view-more">
                  {{ note.expanded ? 'View less' : 'View more' }}
                </a>
                <br> <br>


                <ng-container *ngIf="note.case_id">
                  <span (click)="goToReportTable(note.url)" style=" color: #3c3c3c; cursor: pointer;">
                    <i class="fa fa-eye"></i>
                    View:
                    <span
                      style="cursor: pointer; color: #007bff; text-decoration: underline;margin-right:5px; font-weight:600;">
                      {{ note.case_id }}
                    </span>
                  </span>
                </ng-container>

              </p>




              <div class="meta-row">
                <span class="time">
                  {{ note.created_at | date: 'longDate' }} at {{ note.created_at | date: 'shortTime' }}
                </span>
                <span class="status-ribbon" [ngClass]="note.status">
                  {{ note.status === 'unread' ? 'NEW' : 'SEEN' }}
                </span>
              </div>
            </div>
          </div>


          <div *ngIf="notifications.length === 0" class="no-notifications">
            <div style="font-size: 50px; color: #bebebe; margin-bottom: 10px;">
              <i class="fa fa-bell-slash"></i>
            </div>
            No Notifications Available.!!!
          </div>


        </div>

      </div>












      <div class="dropdown-menu dropdown-menu-right profile-notification" ngbDropdownMenu>
        <div class="pro-head hed">
          <img *ngIf="user?.profile_picture == null" class="img-radius"
            src="{{ user?.profile_picture == null || user?.profile_picture == undefined ? 'assets/images/user/avatar.png' : user?.profile_picture }}"
            alt="User-Profile-Image">
          <span *ngIf="user?.othernames == null">{{ user?.othernames == null || user?.othernames == undefined ? username
            : user?.othernames }}</span>
          <a class="dud-logout" title="Logout"><i class="feather icon-log-out"></i></a>
        </div>
        <ul class="pro-body">
          <li class="mainHover mainActive"><a href="javascript:" [routerLink]="['/profile']" class="dropdown-item"><i
                class="feather icon-user"></i> Profile</a></li>
          <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-mail"></i> My Messages</a></li> -->
          <!-- <li><a href="javascript:" class="dropdown-item"><i class="feather icon-lock"></i> Lock Screen</a></li> -->
          <li class="aHover mainActive"><a href="javascript:" (click)="logout()" class="dropdown-item"><i
                class="feather icon-power"></i> Logout</a></li>
        </ul>
      </div>
    </div>
  </li>
</ul>